import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import Button from "../../components/Button";
import Form from "../../components/Form";
// import { FaAngleLeft } from "react-icons/fa";

import "./steps.scss";
import {
  API_APLICA_BONIFICACION,
  API_GET_AMOUNT_PAY,
  REACT_APP_CAN_GET_ALL_PAY,
  SELECT_PLACEHOLDERS,
  VERSION,
  YEARS,
} from "../../config/config";

import { saveFormState } from "../../utils/formStorage";
import Select from "react-select";
import getListCarrers from "../../services/initial-record/career";
import getListPlaces from "../../services/initial-record/places";
import mediosDePago from "../../images/medios de pago.png";
import getListModes from "../../services/initial-record/modes";
import getListSectors from "../../services/initial-record/sectors";
import getEnrollmentEnabled from "../../services/checkboxs/enrollment-enabled";
import getNotificationCheckbox from "../../services/checkboxs/get-notification";
import { isEmpty } from "../../utils/helpers";
import { AlertOutline } from "../../components/Alert";
import { useToast } from "../../hooks/toast";
import generateTokenService from "../../services/auth/generate-token";
import invoice from "../../services/generate-invoice/boleta";
import signup from "../../services/auth/signup";
import aplicationForAdmission from "../../services/auth/application-for-admission";
import { Loader } from "../../components/Loader";
import ConfirmModal from "../../components/ConfirmModal";
import { maxPhoneNumber, maxPrefixPhone } from "../../utils/const";
import {
  allInscriptions,
  onlyIscriptionCourses,
  onlyIscriptionPostGrado,
  onlyIscriptions,
  typePage,
} from "../../utils/app_manage";

export default function Step2(props) {
  const {
    step,
    setStep,
    token,
    setToken,
    step1Data,
    yearSelected,
    setYearSelected,
    sectorSelected,
    carrerSelected,
    setCarrerSelected,
    placeSelected,
    setPlaceSelected,
    setModeSelected,
    setSectorSelected,
    modeSelected,
    x,
    setX,
    setBoleta,
    setParams,
    loading,
    setLoading,
    setBoletaGenerada,
    generateFullPayment,
    setGenerateFullPayment,
  } = props;

  const setGenerateFullPaymentSafe =
    typeof setGenerateFullPayment === "function" ? setGenerateFullPayment : () => {};

  const [error, setError] = useState(false);
  const [message_text, setMessage] = useState("");
  const [carrers, setCarrers] = useState([]);
  const [places, setPlaces] = useState([]);
  const [modes, setModes] = useState([]);

  const [checkboxEnrrolment, setCheckboxEnrrolment] = useState(false);
  const [urlNotification, setUrlNotification] = useState();
  const [agreementCheckboxEnrrolment, setAgreementCheckboxEnrrolment] =
    useState(false);
  const agreementCheckboxEnrrolment1 = true;
  const [agreementCheckboxNotification, setAgreementCheckboxNotification] =
    useState(false);
  const [agreementCheckboxNotification1, setAgreementCheckboxNotification1] =
    useState(false);

  const [checkboxAgreementEnrrolment, setCheckboxSetAgreementEnrrolment] =
    useState(false);
  const [checkboxAgreementNotification, setCheckboxAgreementNotification] =
    useState(false);

  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [amountToPay, setAmountToPay] = useState(null);
  const [valorMatricula, setValorMatricula] = useState(null);
  const [valorAPagar, setValorAPagar] = useState(null);
  const [matriculaCuota, setMatriculaCuota] = useState(null);
  const [promoPercentage, setPromoPercentage] = useState(0);
  const [promoValidUntil, setPromoValidUntil] = useState(null);
  const [loaderMessage, setLoaderMessage] = useState(null);

  const [canShowFullPayment, setCanShowFullPayment] = useState(false);

  const formatCurrencyARS = (value) => {
    if (value === null || value === undefined || Number.isNaN(Number(value))) return '';
    return Number(value).toLocaleString('es-ar', {
      style: 'currency',
      currency: 'ARS',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  };

  const pad2 = (n) => String(n).padStart(2, '0');

  const formatDateDisplay = (value) => {
    if (!value) return null;

    const [datePart] = value.split('T'); // "2026-04-16"
    if (!datePart) return null;

    const [yyyy, mm, dd] = datePart.split('-');

    return `${dd}/${mm}/${yyyy}`;
  };
  
  const formatPromoDate = ({ anio, mesVencimiento }) => {
    const year = Number(anio);
    const month = Number(mesVencimiento);
    if (Number.isNaN(year) || Number.isNaN(month) || month < 1 || month > 12) return null;
    const lastDay = new Date(year, month, 0);
    const dd = pad2(lastDay.getDate());
    const mm = pad2(lastDay.getMonth() + 1);
    const yyyy = String(lastDay.getFullYear());
    return `${dd}/${mm}/${yyyy}`;
  };

  const getAmountPay = async (overrideParams = {}) => {
    const url = new URL(API_GET_AMOUNT_PAY);
    const pagoTotal = overrideParams?.forcePagoTotalFalse ? false : (canShowFullPayment && !!generateFullPayment && !overrideParams?.onlyAdmision);
    const params = {
      tdocu: step1Data.document_type ?? "",
      ndocu: String(step1Data.document_number ?? ""),
      lugar: Number(placeSelected.value),
      sector: Number(overrideParams.sector ?? sectorSelected.value),
      carrera: Number(carrerSelected.value),
      modo: Number(overrideParams.modo ?? modeSelected.value),
      pagoTotal: pagoTotal ? "true" : "false",
      concepto: 50,
    };

    Object.entries(params).forEach(([k, v]) => url.searchParams.set(k, String(v)));

    const res = await fetch(url.toString());
    if (!res.ok) {
      throw new Error(`get-amount-pay failed: ${res.status}`);
    }
    const data = await res.json();
    const amount = data?.monto_pagar ?? data?.valorFinal ?? data?.valorMatricula;
    if (amount === null || amount === undefined || Number.isNaN(Number(amount))) {
      throw new Error("No se pudo obtener el monto a pagar");
    }
    const porcentaje = Number(data?.porcentaje ?? 0);
    const promoValidUntil = formatDateDisplay(data?.vencimiento);
    const valorMatriculaRaw = data?.valorMatricula ?? null;
    return {
      amount: Number(amount),
      porcentaje: Number.isNaN(porcentaje) ? 0 : porcentaje,
      promoValidUntil,
      valorMatricula: valorMatriculaRaw !== null ? Number(valorMatriculaRaw) : null,
      monto_pagar:data.monto_pagar
    };
  };

  const handleConfirmContinue = () => {
    setIsConfirmModalOpen(false);
    setStep(step + 1);
    setX(1000);
  };

  const postLeadOnCancel = async () => {
    const params = new URLSearchParams(window.location.search);
    const payload = new FormData();

    payload.append('id_origen', '917');
    payload.append('origen', 'inscripcion-abandonada-desde-landing');
    payload.append('modo', String(modeSelected?.value ?? ''));
    payload.append('cbx_carrera', String(carrerSelected?.value ?? ''));
    payload.append('nombre', String(step1Data?.name ?? ''));
    payload.append('apellido', String(step1Data?.surname ?? ''));
    payload.append('email', String(step1Data?.email ?? ''));
    payload.append('cbx_provincia', '16');
    payload.append('cbx_sede', String(placeSelected?.value ?? ''));
    payload.append('tipo_tel', 'celular');
    payload.append('cod_area', String(step1Data?.whatsapp_prefix ?? ''));
    payload.append('tel', String(step1Data?.whatsapp_number ?? ''));

    const ddi = step1Data?.country_code;
    if (ddi !== null && ddi !== undefined && String(ddi).trim() !== '') {
      payload.append('ddi_pais', String(ddi));
    }

    const agent = window?.navigator?.userAgent;
    if (agent) payload.append('agent', agent);

    const referer = document?.referrer;
    if (referer) payload.append('referer', referer);

    const optionalKeys = [
      'gclid',
      'campaignid',
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_term',
      'utm_content',
    ];

    optionalKeys.forEach((key) => {
      const value = params.get(key);
      if (value) payload.append(key, value);
    });

    await fetch('https://www.ucasal.edu.ar/postulantes_mail1.php', {
      method: 'POST',
      body: payload,
      keepalive: true,
    });
  };

  const handleConfirmBack = async () => {
    setIsConfirmModalOpen(false);
    setLoaderMessage('');
    setLoading(true);
    try {
      persistAndRedirect()
      await postLeadOnCancel();
    } catch {
      // no-op
    } finally {
      setLoading(false);
      window.location.assign('https://www.ucasal.edu.ar/');
    }
  };

  const handleRequestClose = () => {
    setIsConfirmModalOpen(false);
  };

  const computeCanShowFullPayment = async ({ modoValue, sectorValue }) => {
    try {
      const modo = Number(modoValue);
      const sector = Number(sectorValue);
      const lugar = Number(placeSelected?.value);
      const carrera = Number(carrerSelected?.value);
      const anioRaw = yearSelected?.value ?? YEARS?.[0];
      const anio = Number(anioRaw);

      const endpoint =API_APLICA_BONIFICACION;

      const missing =
        !endpoint ||
        Number.isNaN(modo) ||
        Number.isNaN(sector) ||
        Number.isNaN(lugar) ||
        Number.isNaN(carrera) ||
        Number.isNaN(anio);

      if (missing) {
        setCanShowFullPayment(false);
        setGenerateFullPaymentSafe(false);
        return;
      }

      const url = new URL(endpoint);
      url.searchParams.set("lugar", String(lugar));
      url.searchParams.set("sector", String(sector));
      url.searchParams.set("carrera", String(carrera));
      url.searchParams.set("modo", String(modo));
      url.searchParams.set("anio", String(anio));

      const res = await fetch(url.toString());
      if (!res.ok) {
        setCanShowFullPayment(false);
        setGenerateFullPaymentSafe(false);
        return;
      }
      const data = await res.json();
      const aplica = data?.aplica === true || data?.aplica === "true" || data?.aplica === 1;
      setCanShowFullPayment(!!aplica);
      if (!aplica) setGenerateFullPaymentSafe(false);
    } catch {
      setCanShowFullPayment(false);
      setGenerateFullPaymentSafe(false);
    }
  };

  const [isLoadingCarrers, setIsLoadingCarrers] = useState(false);
  const [isLoadingPlaces, setIsLoadingPlaces] = useState(false);
  const [isLoadingMode, setIsLoadingMode] = useState(false);

  const [isDisabledCarrers, setIsDisabledCarrers] = useState(true);
  const [isDisabledPlaces, setIsDisabledPlaces] = useState(true);
  const [isDisabledMode, setIsDisabledMode] = useState(true);

  const [isAcc, setIsAcc] = useState(false);

  const { notify: message } = useToast();

  const idTipoNotif = 1;

  useEffect(() => {
    setYearSelected({ value: "", label: SELECT_PLACEHOLDERS.year });
    setCarrerSelected({ value: "", label: SELECT_PLACEHOLDERS.carrer });
    setPlaceSelected({ value: "", label: SELECT_PLACEHOLDERS.place });
    setModeSelected({ value: "", label: SELECT_PLACEHOLDERS.mode });
    setSectorSelected({ value: "", label: SELECT_PLACEHOLDERS.sector });
  }, [
    setYearSelected,
    setCarrerSelected,
    setPlaceSelected,
    setModeSelected,
    setSectorSelected,
    // token,
  ]);

  useEffect(() => {
    const restore = async () => {
      if (!yearSelected?.value) return;

      // 1. cargar carreras
      console.log(yearSelected,carrerSelected,placeSelected,modeSelected)
      await handleSelectYearChange(yearSelected);

      if (!carrerSelected?.value) return;

      // 2. cargar lugares
      await handleSelectCarrerChange(carrerSelected);

      if (!placeSelected?.value) return;

      // 3. cargar modos
      await handleSelectPlaceChange(placeSelected);
      console.log("modeSelected?.value 1",modeSelected?.value)
      // await delay(1000);

      if (!modeSelected?.value) return;
      // 4. cargar sector y cálculos finales
      await handleSelectModeChange(modeSelected);

    };

    restore();
  }, []);

  const handleSelectYearChange = async (selected) => {
    setYearSelected(selected);
    setIsLoadingCarrers(true);
    setIsLoadingPlaces(false);
    setIsLoadingMode(false);
    setIsDisabledCarrers(true);
    setIsDisabledPlaces(true);
    setIsDisabledMode(true);
    setCarrers([]);
    setCarrerSelected({ value: "", label: SELECT_PLACEHOLDERS.carrer });
    setPlaces([]);
    setPlaceSelected({ value: "", label: SELECT_PLACEHOLDERS.place });
    setModes([]);
    setModeSelected({ value: "", label: SELECT_PLACEHOLDERS.mode });

    setSectorSelected({ value: "", label: SELECT_PLACEHOLDERS.sector });
    setError(false);
    setMessage("");

    setCheckboxSetAgreementEnrrolment(false);
    setCheckboxAgreementNotification(false);
    setCheckboxEnrrolment(false);
    setUrlNotification("");

    setCanShowFullPayment(false);
    setGenerateFullPaymentSafe(false);

    setAgreementCheckboxEnrrolment(false);
    setAgreementCheckboxNotification(false);
    setAgreementCheckboxNotification1(false);

    let carrers_array = [];

    if (onlyIscriptionPostGrado()) {
      await getListCarrers({
        token,
        params: {
          anio: selected.value,
          tipoEstudio: "Postgrado",
        },
        callbacks: (response) => {
          if (response) {
            const list = response;
            if (list.length > 0) {
              // const carrers = [156656];
              // const data1 = list.filter(e=> carrers.includes(e.CARRERA_VALUE) );
              // carrers_array = carrers_array.concat(data1.map(item => ({ value: item.CARRERA_VALUE, label: item.CARRERA_LABEL })));
              carrers_array = list.map((item) => ({
                value: item.CARRERA_VALUE,
                label: item.CARRERA_LABEL,
                isACC: item.CARRERA_CCC,
              }));
              //console.log("data11", data1);
            } else {
              // setError(true);
              // setMessage('No hay carreras para seleccionar');
            }
          } else {
            if (response.hasOwnProperty("not_authorized")) {
              if (response.not_authorized) {
                generateTokenService({
                  callbacks: (response) => {
                    if (response.success) {
                      const { token } = response.data;
                      setToken(token);
                    } else {
                      message(response);
                    }
                  },
                });
              } else {
                if (response?.error?.errors.length > 0) {
                  setError(true);
                  message(response);
                  setMessage(response?.error?.errors[0]);
                }
              }
            } else {
              if (response?.error?.errors.length > 0) {
                setError(true);
                message(response);
                setMessage(response?.error?.errors[0]);
              }
            }
          }
        },
      });
    }

    if (onlyIscriptions()) {
      await getListCarrers({
        token,
        params: {
          anio: selected.value,
          tipoEstudio: "Grado",
        },
        callbacks: (response) => {
          if (response) {
            const list = response;
            if (list.length > 0) {
              // const carrers = [156656];
              // const data1 = list.filter(e=> carrers.includes(e.CARRERA_VALUE) );
              // carrers_array = carrers_array.concat(data1.map(item => ({ value: item.CARRERA_VALUE, label: item.CARRERA_LABEL })));
              carrers_array = list.map((item) => ({
                value: item.CARRERA_VALUE,
                label: item.CARRERA_LABEL,
                isACC: item.CARRERA_CCC,
              }));
            } else {
              // setError(true);
              // setMessage('No hay carreras para seleccionar');
            }
          } else {
            if (response.hasOwnProperty("not_authorized")) {
              if (response.not_authorized) {
                generateTokenService({
                  callbacks: (response) => {
                    if (response.success) {
                      const { token } = response.data;
                      setToken(token);
                    } else {
                      message(response);
                    }
                  },
                });
              } else {
                if (response?.error?.errors.length > 0) {
                  setError(true);
                  message(response);
                  setMessage(response?.error?.errors[0]);
                }
              }
            } else {
              if (response?.error?.errors.length > 0) {
                setError(true);
                message(response);
                setMessage(response?.error?.errors[0]);
              }
            }
          }
        },
      });
    }

    if (onlyIscriptions()) {
      await getListCarrers({
        token,
        params: {
          anio: selected.value,
          tipoEstudio: "Pregrado",
        },
        callbacks: (response) => {
          if (response) {
            const list = response;
            //carrers_array = response;
            if (list.length > 0) {
              // const carrers = [156656];
              // const data1 = list.filter(e=> carrers.includes(e.CARRERA_VALUE) );
              carrers_array = carrers_array.concat(
                list.map((item) => ({
                  value: item.CARRERA_VALUE,
                  label: item.CARRERA_LABEL,
                  isACC: item.CARRERA_CCC,
                }))
              );
              //carrers_array.push(list.map(item => ({ value: item.CARRERA_VALUE, label: item.CARRERA_LABEL })));
            } else {
              // setError(true);
              // setMessage('No hay carreras para seleccionar');
            }
          } else {
            if (response.hasOwnProperty("not_authorized")) {
              if (response.not_authorized) {
                generateTokenService({
                  callbacks: (response) => {
                    if (response.success) {
                      const { token } = response.data;
                      setToken(token);
                    } else {
                      message(response);
                    }
                  },
                });
              } else {
                if (response?.error?.errors.length > 0) {
                  setError(true);
                  message(response);
                  setMessage(response?.error?.errors[0]);
                }
              }
            } else {
              if (response?.error?.errors.length > 0) {
                setError(true);
                message(response);
                setMessage(response?.error?.errors[0]);
              }
            }
          }
        },
      });
    }
    if (onlyIscriptionCourses()) {
      await getListCarrers({
        token,
        params: {
          anio: selected.value,
          tipoEstudio: "Curso",
        },
        callbacks: (response) => {
          if (response) {
            const list = response;
            if (list.length > 0) {
              // carrers_array = carrers_array.concat(list.map(item => ({ value: item.carreraValue, label: item.carreraLabel })));
              carrers_array = carrers_array.concat(
                list.map((item) => ({
                  value: item.CARRERA_VALUE,
                  label: item.CARRERA_LABEL,
                  isACC: item.CARRERA_CCC,
                }))
              );
            } else {
              // setError(true);
              // setMessage('No hay carreras para seleccionar');
            }
          } else {
            if (response.hasOwnProperty("not_authorized")) {
              if (response.not_authorized) {
                generateTokenService({
                  callbacks: (response) => {
                    if (response.success) {
                      const { token } = response.data;
                      setToken(token);
                    } else {
                      message(response);
                    }
                  },
                });
              } else {
                if (response?.error?.errors.length > 0) {
                  setError(true);
                  message(response);
                  setMessage(response?.error?.errors[0]);
                }
              }
            } else {
              if (response?.error?.errors.length > 0) {
                setError(true);
                message(response);
                setMessage(response?.error?.errors[0]);
              }
            }
          }
        },
      });
    }
    setCarrers(carrers_array);
    await setIsLoadingCarrers(false);
    await setIsDisabledCarrers(false);
  };

  const generateRowPlace = (carrerSelected) => {
    if (
      // carrerSelected.LUGARVALUE == 500 ||
      // carrerSelected.CARRERA_CON_ADMISION == "Si"
      carrerSelected.URL != " - "
    ) {
      return {
        ...carrerSelected,
        value: carrerSelected.LUGARVALUE,
        label: carrerSelected.LUGARLABEL,
        admission: true,
      };
    }

    return {
      ...carrerSelected,
      value: carrerSelected.LUGARVALUE,
      label: carrerSelected.LUGARLABEL,
      admission: false,
    };
  };

  const handleSelectCarrerChange = async (selected) => {
    setCarrerSelected(selected);
    setIsLoadingPlaces(true);
    setIsLoadingMode(false);
    setIsDisabledPlaces(true);
    setIsDisabledMode(true);
    setPlaces([]);
    setPlaceSelected({ value: "", label: SELECT_PLACEHOLDERS.place });
    setModes([]);
    setModeSelected({ value: "", label: SELECT_PLACEHOLDERS.mode });

    setSectorSelected({ value: "", label: SELECT_PLACEHOLDERS.sector });
    setError(false);
    setMessage("");

    setCheckboxSetAgreementEnrrolment(false);
    setCheckboxAgreementNotification(false);
    setCheckboxEnrrolment(false);
    setUrlNotification("");
    setAgreementCheckboxEnrrolment(false);
    setAgreementCheckboxNotification(false);
    setAgreementCheckboxNotification1(false);
    await getListPlaces({
      token,
      params: { carrera: selected.value, "tipo-estudio": "Pregrado" },
      callbacks: async (response) => {
        if (response) {
          const c= selected.value;
          // const presenciales = [26,28,148,173,179,1,4,6,69,94,105,109,220,221,222,223,2,100,320,46,68,146,372,132,70,232,371,340,358,56,342,341,31,32,238,18,19,83,84,117,139,47,249,343,323,142,332,174,123,231,176,385];
          
          let list = response;
          // if(!presenciales.includes(c)){
          //   //const firstElement = Array.isArray(data) && data.length > 0 ? data[0] : null;
          //   list = response;  
          // }else{
          //    list = [response[0]];
          // }
          
          if (list.length > 0) {
            setIsLoadingPlaces(false);
            setIsDisabledPlaces(false);
            //quitar el lugar Arequi por pedido de marketing
            const i = list.findIndex((item) => item.LUGARVALUE == 47);
            let data;
            if (onlyIscriptions()) {
              data = list.map(
                (item) => generateRowPlace(item)
                //   {
                //   value: item.LUGARVALUE,
                //   label: item.LUGARLABEL,
                //   // admission: generateRowPlace(item),
                //   url:item.URL,
                //   id_admision:item.ID_ADMISION
                // }
              );
            } else {
              data = list.map((item) => ({
                value: item.LUGARVALUE,
                label: item.LUGARLABEL,
              }));
            }
            if (i > -1) data.splice(i, 1);
            
            // Group places into SEDES OFICIALES and SEDES HOME
            const sedesOficiales = data.filter((item) => item.value != 500);
            const sedesHome = data.filter((item) => item.value == 500);
            
            const groupedData = [];
            if (sedesOficiales.length > 0) {
              groupedData.push({
                label: "SEDES OFICIALES",
                options: sedesOficiales
              });
            }
            if (sedesHome.length > 0) {
              groupedData.push({
                label: "SEDES HOME",
                options: sedesHome
              });
            }
            
            setPlaces(groupedData);
          } else {
            setError(true);
            setMessage("No hay lugares de estudio para seleccionar");
          }
        } else {
          if (response.hasOwnProperty("not_authorized")) {
            if (response.not_authorized) {
              generateTokenService({
                callbacks: (response) => {
                  if (response.success) {
                    const { token } = response.data;
                    setToken(token);
                  } else {
                    message(response);
                  }
                },
              });
            } else {
              if (response?.error?.errors.length > 0) {
                setError(true);
                message(response);
                setMessage(response?.error?.errors[0]);
              }
            }
          } else {
            if (response?.error?.errors.length > 0) {
              setError(true);
              message(response);
              setMessage(response?.error?.errors[0]);
            }
          }
        }
      },
    });
  };

  const handleSelectPlaceChange = async (selected) => {
    setPlaceSelected(selected);
    setIsLoadingMode(true);
    setIsDisabledMode(true);
    setModes([]);
    setModeSelected({ value: "", label: SELECT_PLACEHOLDERS.mode });
    setSectorSelected({ value: "", label: SELECT_PLACEHOLDERS.sector });
    setError(false);
    setMessage("");

    setCheckboxSetAgreementEnrrolment(false);
    setCheckboxAgreementNotification(false);
    setCheckboxEnrrolment(false);
    setUrlNotification("");
    setAgreementCheckboxEnrrolment(false);
    setAgreementCheckboxNotification(false);
    setAgreementCheckboxNotification1(false);
    await getListModes({
      token,
      params: {
        lugar: selected.value,
        tipoEstudio: "Pregrado",
        carrera: carrerSelected.value,
      },
      callbacks: (response) => {
        if (response.success) {
          const list = response.data;
          if (list.length > 0) {
            setIsLoadingMode(false);
            setIsDisabledMode(false);
            setModes(
              list.map((item) => ({
                value: item.modoValue,
                label: item.modoLabel,
              }))
            );
          } else {
            setError(true);
            setMessage("No hay modalidad de estudio para seleccionar");
          }
        } else {
          if (response.hasOwnProperty("not_authorized")) {
            if (response.not_authorized) {
              generateTokenService({
                callbacks: (response) => {
                  if (response.success) {
                    const { token } = response.data;
                    setToken(token);
                  } else {
                    message(response);
                  }
                },
              });
            } else {
              if (response?.error?.errors.length > 0) {
                setError(true);
                message(response);
                setMessage(response?.error?.errors[0]);
              }
            }
          } else {
            if (response?.error?.errors.length > 0) {
              setError(true);
              message(response);
              setMessage(response?.error?.errors[0]);
            }
          }
        }
      },
    });
  };

  const handleSelectModeChange = async (selected) => {
    setCanShowFullPayment(false);
    setGenerateFullPaymentSafe(false);
    setModeSelected(selected);
    setSectorSelected({ value: "", label: SELECT_PLACEHOLDERS.sector });
    setError(false);
    setMessage("");

    setCheckboxSetAgreementEnrrolment(false);
    setCheckboxAgreementNotification(false);
    setCheckboxEnrrolment(false);
    setUrlNotification("");
    setAgreementCheckboxEnrrolment(false);
    setAgreementCheckboxNotification(false);
    setAgreementCheckboxNotification1(false);

    setCanShowFullPayment(false);
    setGenerateFullPaymentSafe(false);

    setIsAcc(carrerSelected?.isACC === "Si");

    await getListSectors({
      token,
      params: {
        modo: selected.value,
        lugar: placeSelected.value,
        tipoEstudio: "Pregrado",
        carrera: carrerSelected.value,
      },
      callbacks: async (response) => {
        if (response.success) {
          const list = response.data;
          if (list.length > 0) {
            const sector = list.map((item) => ({
              value: item.sectorValue,
              label: item.sectorLabel,
            }))[list.length - 1];
            setSectorSelected(sector);


            // Obtener el monto a pagar antes de continuar con el resto de endpoints
            setAmountToPay(null);
            setPromoPercentage(0);
            setPromoValidUntil(null);
            try {
              const result = await getAmountPay({onlyAdmision:true ,sector: sector.value, modo: selected.value });
              console.log("result",result,{ sector: sector.value, modo: selected.value })

              setAmountToPay(result.amount);
              setValorAPagar(result.monto_pagar)
              setValorMatricula(result.valorMatricula);
              setPromoPercentage(result.porcentaje);
              setPromoValidUntil(result.promoValidUntil);
            } catch (amountError) {
              console.error("Error al obtener monto de matrícula:", amountError);
            }


            await computeCanShowFullPayment({
              modoValue: selected.value,
              sectorValue: sector.value,
            });

            await getEnrollmentEnabled({
              token: token,
              params: {
                tdocu: step1Data.document_type,
                ndocu: step1Data.document_number,
                lugar: placeSelected.value,
                sector: sector.value,
                carrera: carrerSelected.value,
                modo: selected.value,
                anio: yearSelected.value,
              },
              callbacks: (response) => {
                if (response.success) {
                  const list = response.data;
                  setCheckboxEnrrolment(list);
                  setAgreementCheckboxEnrrolment(false);
                  setAgreementCheckboxNotification(false);
                } else {
                  // TODO: revisar el mensaje de error
                  setError(true);
                  message(response);
                  setMessage(response.error.errors[0]);
                  setCheckboxEnrrolment(false);
                  setAgreementCheckboxEnrrolment(false);
                  setAgreementCheckboxNotification(false);
                  setUrlNotification(null);
                }
                setAgreementCheckboxNotification1(false);
              },
            });

            await getNotificationCheckbox({
              token: token,
              params: {
                lugar: placeSelected.value,
                sector: sector.value,
                carrera: carrerSelected.value,
                modo: selected.value,
                idTipoNotif: idTipoNotif,
              },
              callbacks: (response) => {
                if (response.success) {
                  const { url } = response.data;
                  if (url && !isEmpty(url)) {
                    if (typeof url === "object" && url.length) {
                      if (url[0]) {
                        setUrlNotification(url[0].replace("8/", ""));
                      } else {
                        setUrlNotification(null);
                        setAgreementCheckboxNotification(true);
                      }
                    } else {
                      setUrlNotification(url.replace("8/", ""));
                    }
                  } else {
                    setUrlNotification(null);
                    setAgreementCheckboxNotification(true);
                  }
                } else {
                  if (response?.error?.errors.length > 0) {
                    setError(true);
                    message(response);
                    setMessage(response?.error?.errors[0]);
                  }
                }
              },
            });
          } else {
            setError(true);
            setMessage(
              "No fue posible obtener los aranceles para esta carrera. Por favor, contacte con un asesor."
            );
            // setSectorSelected({ value: "", label: SELECT_PLACEHOLDERS.sector });
            // setCheckboxEnrrolment(false);
            // setAgreementCheckboxEnrrolment(false);
            // setAgreementCheckboxNotification(false);
            // setAgreementCheckboxNotification1(false);
            // setUrlNotification(null);
          }
        } else {
          if (response.hasOwnProperty("not_authorized")) {
            if (response.not_authorized) {
              generateTokenService({
                callbacks: (response) => {
                  if (response.success) {
                    const { token } = response.data;
                    setToken(token);
                  } else {
                    message(response);
                  }
                },
              });
            } else {
              if (response?.error?.errors.length > 0) {
                setError(true);
                message(response);
                setMessage(response?.error?.errors[0]);
              }
            }
          } else {
            if (response?.error?.errors.length > 0) {
              setError(true);
              message(response);
              setMessage(response?.error?.errors[0]);
            }
          }
        }
      },
    });
  };

  const checkComprobationStep2 = () => {
    const hasMissingSelections =
      isEmpty(placeSelected?.value) ||
      isEmpty(modeSelected?.value) ||
      isEmpty(sectorSelected?.value);

    if (onlyIscriptions()) {
      return (
        hasMissingSelections ||
        !agreementCheckboxEnrrolment ||
        !agreementCheckboxNotification 
      );
    }
    if (onlyIscriptionCourses()) {
      return hasMissingSelections || !agreementCheckboxEnrrolment;
      // !agreementCheckboxNotification ||
      // !agreementCheckboxEnrrolment1
    }
    if (onlyIscriptionPostGrado()) {
      return (
        hasMissingSelections ||
        !agreementCheckboxEnrrolment ||
        !agreementCheckboxNotification 
      );
    }
  };

  const handleChangeCheckboxEnrrolment = (event) => {
    setAgreementCheckboxEnrrolment(event.target.checked);
    setCheckboxSetAgreementEnrrolment((current) => !current);
  };

  const handleChangeCheckboxNotification = (event) => {
    setAgreementCheckboxNotification(event.target.checked);
    setCheckboxAgreementNotification((current) => !current);
  };

  async function validateAdmission(sector, mode) {
    const country_code = (step1Data.country_code ?? "")
      .toString()
      .replace(/\D/g, "")
      .slice(0, maxPrefixPhone);

    const prefix = (step1Data.whatsapp_prefix ?? "")
      .toString()
      .replace(/\D/g, "")
      .slice(0, maxPrefixPhone);

    const phoneNumber = (step1Data.whatsapp_number ?? "")
      .toString()
      .replace(/\D/g, "")
      .slice(0, maxPhoneNumber);

    let params = {
      apellido: step1Data.surname,
      nombre: step1Data.name,
      tdocu: step1Data.document_type,
      ndocu: step1Data.document_number.toString(),
      codTelefono: country_code,
      telefono: `${prefix}${phoneNumber}`,
      email: step1Data.email.toString(),
      tipoEstudio: "Grado",
      anio: yearSelected.value,
      carrera: carrerSelected.value,
      lugar: placeSelected.value,
      modo: mode,
      // modeSelected.value.toString()
      sector: sector,
    };
    setParams(params);
    // setLoading(true);
    
    return true 
    // new Promise((resolve, reject) => {
    //   signup({
    //     token: token,
    //     params: params,
    //     callbacks: async (response) => {
    //       setLoading(true);
    //       if (response.success) {
    //         await new Promise((resolveAdmission, rejectAdmission) => {
    //           aplicationForAdmission({
    //             token: token,
    //             params: params,
    //             callbacks: async (response) => {
    //               if (response?.data > 0) {
    //                 setError(false);
    //                 setCheckboxEnrrolment(true);
    //                 setAgreementCheckboxEnrrolment(false);
    //                 setAgreementCheckboxNotification(false);
    //                 resolveAdmission(response);
    //               } else {
    //                 setError(true);
    //                 message(response);
    //                 setMessage(response?.error?.errors[0]);
    //                 setCheckboxEnrrolment(false);
    //                 setAgreementCheckboxEnrrolment(false);
    //                 setAgreementCheckboxNotification(false);
    //                 rejectAdmission(response);
    //               }
    //             },
    //           });
    //         });
    //         resolve(response);
    //       } else {
    //         message(response);
    //         setLoading(false);
    //         reject(response);
    //       }
    //     },
    //   });
    // });
  }

  async function changeSteep3(event) {
    event.preventDefault();

    try {
      if (loading) return;
      await validateAdmission(sectorSelected.value, modeSelected.value);

      setAmountToPay(null);
      setPromoPercentage(0);
      setPromoValidUntil(null);
      setMatriculaCuota(null);

      setLoading(true);
      setLoaderMessage('Obteniendo el monto de la matrícula, por favor esperá...');
      const result = await getAmountPay();
      console.log("result",result)
      setAmountToPay(result.amount);
      setValorAPagar(result.monto_pagar)
      setValorMatricula(result.valorMatricula);
      setPromoPercentage(result.porcentaje);
      setPromoValidUntil(result.promoValidUntil);

      // If generateFullPayment is true, make another call with pagoTotal = false to get matricula price only
      if (generateFullPayment) {
        const matriculaResult = await getAmountPay({ forcePagoTotalFalse: true });
        setMatriculaCuota(matriculaResult.monto_pagar);
      }

      setIsConfirmModalOpen(true);
      
      // let params_to_invoice = {
      //   tdocu: step1Data.document_type,
      //   ndocu: step1Data.document_number.toString(),
      //   carrera: carrerSelected.value,
      //   lugar: placeSelected.value,
      //   modo: modeSelected.value,
      //   sector: sectorSelected.value,
      //   anio: yearSelected.value,
      //   tipo_carrera: "Grado",
      // };
      // setBoleta(params_to_invoice);
      // await invoice({
      //   params: params_to_invoice,
      //   token: token,
      //   callbacks: async (response) => {
      //     if (response.success) {
      //       if (response.data.length > 0) {
      //         let data = response.data.filter(
      //           (item) => item.concepto === 50 || item.concepto === 590
      //         );
      //         if (data.length > 0) {
      //           data = data[0];
      //           if (data.hasOwnProperty("concepto") && !isEmpty(data.concepto)) {
      //             setLoading(false);
      //             setBoletaGenerada(data);
      //           } else {
      //             setLoading(false);
      //             message({
      //               success: false,
      //               message:
      //                 "No se pudo generar la boleta. Intente nuevamente mas tarde ",
      //             });
      //           }
      //         } else {
      //           const otherConcepts = response.data.filter(
      //             (item) => ![50, 590].includes(item.concepto)
      //           );

      //           message({
      //             success: false,
      //             message:
      //               otherConcepts.length > 0
      //                 ? "Ya se abonó el concepto de matrícula o inscripción al curso de ingreso. Por favor, continúe en el sistema de autogestión."
      //                 : "No se pudo generar la boleta. Intente nuevamente mas tarde",
      //           });
      //         }
      //       } else {
      //         message({
      //           success: false,
      //           message:
      //             "No se pudo generar la boleta. Intente nuevamente mas tarde",
      //         });
      //       }
      //     } else {
      //       message(response);
      //     }
      //   },
      // });
    } catch (error) {
      setLoading(false);
      console.error("Error en validateAdmission:", error);
    }
    finally {
      setLoading(false);
      setLoaderMessage(null);
    }
  }

  const persistAndRedirect = () => {
      saveFormState({
        step: 1,
        step1Data,
        yearSelected,
        carrerSelected,
        placeSelected,
        modeSelected,
      });
    };

  return (
    <motion.div
      initial={{ x: x }}
      transition={{ duration: 0.5 }}
      animate={{ x: 0 }}
    >
      <div className="box">
        <Form className="form-flex">
          <div className="box-header">
            {/* <div className="icon-back" onClick={() => { setStep(step - 1); setX(-1000); }}>
                            <FaAngleLeft />
                        </div> */}
            <span className="step-numer">{step + 1}</span>
            <h2>Elegí tu  { onlyIscriptionCourses() ? "capacitación" : "carrera"}</h2>
          </div>
          <div className="box-body">
            <div className="d-flex my-1">
              <Select
                label={yearSelected.label}
                className="width-100"
                options={YEARS.map((item) => ({ value: item, label: item }))}
                value={yearSelected}
                onChange={handleSelectYearChange}
                placeholder="Seleccione un año"
                noOptionsMessage={() => "No hay opciones"}
              />
            </div>
            <div className="d-flex my-1">
              <Select
                label={carrerSelected.label}
                className="width-100"
                options={carrers ?? []}
                value={carrerSelected}
                onChange={handleSelectCarrerChange}
                placeholder={onlyIscriptionCourses() ? "Una capacitación" : "Una carrera"}
                noOptionsMessage={() => "No hay opciones"}
                isLoading={isLoadingCarrers}
                isDisabled={isDisabledCarrers}
              />
            </div>
            <div className="d-flex my-1">
              <Select
                label={placeSelected.label}
                className="width-100"
                options={places}
                value={placeSelected}
                onChange={handleSelectPlaceChange}
                placeholder="Selecciona un lugar de estudio"
                noOptionsMessage={() => "No hay opciones"}
                isLoading={isLoadingPlaces}
                isDisabled={isDisabledPlaces}
                styles={{
                  groupHeading: (base) => ({
                    ...base,
                    fontSize: '14px',
                    fontWeight: 'bold',
                    color: '#0066cc',
                    padding: '8px 12px'
                  })
                }}
              />
            </div>

            <div className="d-flex my-1">
              <Select
                className="width-100"
                options={modes}
                label={modeSelected.label}
                value={modeSelected}
                onChange={handleSelectModeChange}
                placeholder="Selecciona una modalidad de estudio"
                noOptionsMessage={() => "No hay opciones"}
                isLoading={isLoadingMode}
                isDisabled={isDisabledMode}
              />
            </div>
            {/* placeSelected.URL {placeSelected.URL} <br />
            isAcc {isAcc ? "true":'false' } <br />
            carrerSelected.value {carrerSelected.value} <br /> */}
            {error && (
              <>
                <AlertOutline>
                  {!!placeSelected.URL ? (
                    <>
                      La {onlyIscriptionCourses() ? "capacitación" : "carrera"} seleccionada requiere admisión
                      {(/ccc-form/i.test(
                          (isAcc
                            ? "https://www.ucasal.edu.ar/carreras/ccc-form.php"
                            : placeSelected.URL
                          )
                        )) ? (
                          <p>
                            Es exclusiva para quienes tengan un Título previo afín, el cual será evaluado para confirmar que cumple con los requisitos de ingreso.
                          </p>
                        ) : (/admision-form/i.test(
                          (isAcc
                            ? "https://www.ucasal.edu.ar/carreras/ccc-form.php"
                            : placeSelected.URL
                          )
                        )) && (
                          <p>
                            Es exclusiva para personas que residan a más de 100 km de una sede
                          </p>
                        )}                       
                      {/* este se renderiza casi siempre */}
                     {valorMatricula !== null && (
                        <div style={{width:"100%", marginBottom: '5px' }}>
                          <span style={{width:"100%", textAlign:"center" ,fontWeight: 'normal', color:promoPercentage?'red':'black'}}>
                            Monto de matrícula:<span style={{textDecoration: promoPercentage?'line-through':'', }}>
                                {formatCurrencyARS(valorMatricula)} 
                            </span> 
                          </span>
                          <br/>
                          {promoPercentage > 0 && promoValidUntil && (
                            <>
                              <span style={{width:"100%", textAlign:"center" , fontWeight: 'bold', color: 'green' }}>
                                {promoPercentage > 0 ? 'Matrícula con descuento: ' : 'Monto de matrícula: '}{formatCurrencyARS(valorAPagar)}
                              </span>
                              
                              <p style={{width:"100%", textAlign:"left" , fontWeight: 'bold' }}>
                                ({promoPercentage}% OFF hasta {promoValidUntil})  
                              </p>
                            </>
                        )}
                        </div>
                      )}
                      <div className="btn-group btn-footer-link-admision-new" >
                        <Link
                          className="btn form-admision-link"
                          to={
                            `${
                              isAcc
                                ? "https://www.ucasal.edu.ar/carreras/ccc-form.php"
                                : placeSelected.URL
                            }?carrera=` + carrerSelected.value
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Completar Admisión
                        </Link>
                        <Button
                          type="button"
                          className="btn form-admision-goback"
                          onClick={() => {
                            setStep(step - 1);
                            setX(-1000);
                          }}
                        >
                          Volver
                        </Button>
                      </div>
                    </>
                  )
                   : message_text && !isEmpty(message_text) ? (
                    <>
                      {message_text}
                      {valorMatricula !== null && (
                        <div style={{ marginBottom: '5px' }}>
                          {promoPercentage > 0 && (
                            <span style={{width:"100%", textAlign:"center" ,fontWeight: 'normal', color:promoPercentage?'red':'black'}}>
                              Monto de matrícula:<span style={{textDecoration: promoPercentage?'line-through':'', }}>
                                  {formatCurrencyARS(valorMatricula)} 
                              </span> 
                            </span> 
                          )}
                          <span style={{ fontWeight: 'bold', color: 'green' }}>
                            {promoPercentage > 0 ? 'Matrícula con descuento: ' : 'Monto de matrícula: '}{formatCurrencyARS(valorMatricula)}
                          </span>
                        </div>
                      )}
                      {promoPercentage > 0 && promoValidUntil && (
                        <p style={{ fontWeight: 'bold' }}>
                          ({promoPercentage}% OFF hasta {promoValidUntil})
                        </p>
                      )}
                    </>
                  ) : (
                    <>
                      La {onlyIscriptionCourses() ? "capacitación" : "carrera"} seleccionada requiere admisión 
                      {(/ccc-form/i.test(
                          (isAcc
                            ? "https://www.ucasal.edu.ar/carreras/ccc-form.php"
                            : placeSelected.URL
                          )
                        )) ? (
                          <p>
                            Es exclusiva para quienes tengan un Título previo afín, el cual será evaluado para confirmar que cumple con los requisitos de ingreso.
                          </p>
                        ) : (/admision-form/i.test(
                          (isAcc
                            ? "https://www.ucasal.edu.ar/carreras/ccc-form.php"
                            : placeSelected.URL
                          )
                        )) && (
                          <p>
                            Es exclusiva para personas que residan a más de 100 km de una sede
                          </p>
                        )}

                      {valorMatricula !== null && (
                        <div style={{width:"100%", marginBottom: '5px' }}>
                          <span style={{width:"100%", textAlign:"left" ,fontWeight: 'normal', textDecoration: promoPercentage?'line-through':'', color:promoPercentage?'red':'black'}}>
                            Monto de matrícula: {formatCurrencyARS(valorMatricula)}
                          </span>
                          <br/>
                          {promoPercentage > 0 && promoValidUntil && (
                            <>
                              <span style={{width:"100%", textAlign:"left" , fontWeight: 'bold', color: 'green' }}>
                                {promoPercentage > 0 ? 'Matrícula con descuento: ' : 'Monto de matrícula: '}{formatCurrencyARS(valorAPagar)}
                              </span>
                              
                              <p style={{width:"100%", textAlign:"left" , fontWeight: 'bold' }}>
                                ({promoPercentage}% OFF hasta {promoValidUntil})
                              </p>
                            </>
                        )}
                        </div>
                      )}
                  
                      <div className="btn-group btn-footer-link-admision-new">
                        <Link
                          className="btn form-admision-link"
                          to={
                            `${
                              isAcc
                                ? "https://www.ucasal.edu.ar/carreras/ccc-form.php"
                                : placeSelected.URL
                            }?carrera=` + carrerSelected.value
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Completar Admisión
                        </Link>
                        <Button
                          type="button"
                          className="btn form-admision-goback"
                          onClick={() => {
                            setStep(step - 1);
                            setX(-1000);
                          }}
                        >
                          Volver
                        </Button>
                      </div>
                    </>
                  )}
                </AlertOutline>
              </>
            )}

            <div className="checkbox">
              {canShowFullPayment && checkboxEnrrolment && !error && (
                <div className="d-flex my-1">
                  <input
                    type="checkbox"
                    id="generate_full_payment"
                    checked={generateFullPayment}
                    onChange={(e) => setGenerateFullPaymentSafe(e.target.checked)}
                    className="mr-1"
                  />
                  <label htmlFor="generate_full_payment">
                    Quiero acceder al beneficio de matrícula bonificada (100%) y abonar las 7 cuotas del cursado por adelantado. (Opcional)
                  </label>
                </div>
              )}

              {checkboxEnrrolment && !error && (
                <div className="d-flex my-1">
                  <input
                    type="checkbox"
                    checked={checkboxAgreementEnrrolment}
                    onChange={handleChangeCheckboxEnrrolment}
                    name="bases_and_conditions_of_reimbursement"
                    id="bases_and_conditions_of_reimbursement"
                    className="mr-1"
                  />
                  <label htmlFor="bases_and_conditions_of_reimbursement">
                    <a
                      href={`https://sistemasweb.ucasal.edu.ar/v1/boleta/terminos-y-condiciones-reintegro`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Acepto bases y condiciones de reintegro
                    </a>
                  </label>
                </div>
              )}

              {!isEmpty(urlNotification) && !error && (
                <div className="d-flex my-1">
                  <input
                    type="checkbox"
                    checked={checkboxAgreementNotification}
                    onChange={handleChangeCheckboxNotification}
                    name="bases_and_conditions_on_the_modality"
                    id="bases_and_conditions_on_the_modality"
                    className="mr-1"
                  />
                  <label htmlFor="bases_and_conditions_on_the_modality">
                    <a
                      // mnt/reponotifs/NOTIFICACI%C3%93N%20OBLIGATORIA%20CCC%20-ALUMNOS%2020-10-2023.pdf
                      href={`https://www.ucasal.edu.ar/reponotifs${urlNotification}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Acepto bases y condiciones sobre la modalidad
                    </a>
                  </label>
                </div>
              )}

              {/* {checkboxEnrrolment && !onlyIscriptionCourses() && !error && (
                <div className="d-flex my-1">
                  <input
                    type="checkbox"
                    checked={checkboxAgreementEnrrolment1}
                    onChange={handleChangeCheckboxEnrrolment1}
                    name="notification_1"
                    id="notification_1"
                    className="mr-1"
                  />
                  <label className="justify-content" htmlFor="notification_1">
                    Me notifico de que para ingresar a Ucasal debo tener el
                    secundario completo. En caso de tener
                    asignaturas pendientes 
                    <b> NO deberé matricularme </b> <br /> y volveré a contactar una
                    vez obtenido ese requisito. <br />
                    <b>
                      {" "}
                      No habrá lugar a reclamos ni devoluciones de dinero.{" "}
                    </b>
                  </label>
                </div>
              )} */}
            </div>
          </div>
          {!error && (
            <div className="box-footer btn-group">
              {loading ? (
                <Loader message={loaderMessage} />
              ) : (
                <>
                  <Button
                    type="button"
                    className="btn-step btn-goback"
                    onClick={() => {
                      setStep(step - 1);
                      setX(-1000);
                    }}
                  >
                    Volver
                  </Button>
                  <Button
                    type="submit"
                    className="btn-step"
                    disabled={checkComprobationStep2()}
                    onClick={changeSteep3}
                  >
                    Siguiente
                  </Button>
                </>
              )}
            </div>
          )}
          <ConfirmModal
            isOpen={isConfirmModalOpen && !loading}
            // title={`Confirmación de ${onlyIscriptionCourses() ? "capacitación" : "carrera"}`}
            title="Confirmación de inscripción"
            onConfirm={handleConfirmContinue}
            onCancel={handleConfirmBack}
            onRequestClose={handleRequestClose}
          >
            <p>Estás por preinscribirte {onlyIscriptionCourses() ? "capacitación" : "a "} {carrerSelected.label}.</p>
            {generateFullPayment ? (
              <>
                <div style={{width:"80%",marginLeft:"5%"}}>
                  <p  style={{textAlign:'left'}}  className="font-bold">Promoción aplicada</p>
                  <p  style={{textAlign:'left'}} >✅ Matrícula bonificada al 100%</p>
                  <p  style={{textAlign:'left'}} className="font-bold" >Detalle de pago</p>
                </div>
                <div style={{width:"80%",marginLeft:"10%"}}>
                  <ul style={{textAlign:'left' ,marginLeft:"5%"}}>
                    <li>7 cuotas de {formatCurrencyARS(valorMatricula/7)}</li>
                    <li>Total del plan: {formatCurrencyARS(amountToPay)}</li>
                  </ul>
                </div>
                <div style={{width:"80%",marginLeft:"5%"}}>
                  <p  style={{textAlign:'left'}}  className="font-bold">Ahorro obtenido</p>
                </div>
                <div style={{width:"80%",marginLeft:"10%"}}>
                  <ul style={{textAlign:'left' ,marginLeft:"5%"}}>
                    <li>Matrícula bonificada: {formatCurrencyARS(matriculaCuota)} </li>
                  </ul>
                </div>

              </>
            ) : (
                  <>
                    <div style={{ width: "80%", marginLeft: "5%", textAlign: "left" }}>
                      <span
                        style={{
                          display: "block",
                          color: promoPercentage > 0 ? "#c00" : "black",
                          textDecoration: promoPercentage > 0 ? "line-through" : "none",
                        }}
                      >
                        Monto de matrícula: {formatCurrencyARS(valorMatricula)}
                      </span>

                      {/* Precio con descuento */}
                      {promoPercentage > 0 && (
                        <>
                          <span
                            style={{
                              display: "block",
                              fontWeight: "bold",
                              color: "green",
                              marginTop: "4px",
                            }}
                          >
                            Matrícula con descuento: {formatCurrencyARS(valorAPagar)}
                          </span>

                          <p style={{ marginTop: "4px" }}>
                            ({promoPercentage}% OFF hasta {promoValidUntil})
                          </p>
                        </>
                      )}
                    </div>
                  </>
            )}

            <div style={{width:"80%",marginLeft:"5%",textAlign:"left"}}>
              <p>
                Recorda que podes financiar este monto con los medios de pagos disponibles
              </p>
              <img style={{width:"100%"}} src={mediosDePago} alt="Medios de pago" />
            </div>

            <p>¿Deseás continuar?</p>
          </ConfirmModal>
          <span className="version">{VERSION}</span>
        </Form>
      </div>
    </motion.div>
  );
}
